export default __webpack_public_path__ + "static/media/proceedToCheckout-help.e9ffde3f.png";